/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import axios from 'axios';
import api from './api.services';
import {fetchApiDataFailure} from '../_actions/common.actions';
import { fetchCourseSuccess } from "../_actions/coursedetails.actions";
import {showMessage} from "../_actions/message.actions";

export const getCourseDetails = (collectionId)=> (dispatch) => {
    return axios.get(api.get_course_details.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchCourseSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};

export const saveCourseDetails = collectionId => (dispatch, getState) => {
    let courseUpdateDetails = getState().registrarCourseSectionDetails.courseChangesDetails;
    Object.keys(courseUpdateDetails).forEach(courseId => {
        axios.put(api.save_course_details.replace('{collectionId}', collectionId).replace('{courseId}', courseId), { courseId, endDate: courseUpdateDetails[courseId].endDate })
            .then(response => {
                dispatch(showMessage({ messageKey: 'default_success', type: 'success' }));

            })
            .catch(error => {
                dispatch(fetchApiDataFailure(error));
                dispatch(showMessage({ messageKey: 'default_failed', type: 'error' }));
            });
    });

};

export const addNewInstructorCourseDetails = ({ collectionId, courseId, instructor_name }) => (dispatch) => {
    axios.post(api.add_instructor_course_details.replace('{collectionId}', collectionId).replace('{courseId}', courseId), { instructor_name })
        .then(response => {
            dispatch(showMessage({ messageKey: 'add_instructor_success', type: 'success' }));
            dispatch(getCourseDetails(collectionId));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({ messageKey: 'add_instructor_failed', type: 'error' }));
        });
};


// WEBPACK FOOTER //
// ./src/_thunks/coursedetails.thunk.js